/* eslint-disable react/display-name */
import React, { createContext, useState, useEffect } from 'react';
import LazyLoad from 'vanilla-lazyload';

// Create a new React context
const Context = createContext();
// Add the image class name our LazyLoad plugin should look for
const options = {
  elements_selector: '.et-common_lazyImage__img',
  class_loaded: 'et-common_lazyImage__loaded',
  class_loading: 'et-common_lazyImage__loading',
  thresholds: '100px 50%'
};

export const LazyImageProvider = ({ children, container }) => {
  // Create the state that will hold the LazyLoad API
  const [ lazyLoad, setLazyLoad ] = useState(null);
  const [ numLoaded, setNumLoaded ] = useState(0);

  useEffect(() => {
    if (!container) return;

    // Initialise LazyLoad only if it doesn't exist yet
    if (!lazyLoad) setLazyLoad(new LazyLoad({
      ...options,
      container,
      callback_loaded: (el) => {
        setNumLoaded( num => (num + 1) );
        el && el.removeAttribute('data-src');
      },
    }));

    // Clean up on unmount
    return () => lazyLoad && lazyLoad.destroy();
  }, [ lazyLoad, container ]);

  // Expose our LazyLoad API to its children components
  return <Context.Provider value={{ lazyLoad, numLoaded }}>{children}</Context.Provider>;
};

// Export the with context so we can access the LazyLoad API in other components
export const withLazyImageContext = Component => props => (
  <Context.Consumer>
    {({ lazyLoad, numLoaded } = {}) => <Component {...props} lazyLoad={lazyLoad} numLazyLoaded={numLoaded} />}
  </Context.Consumer>
);

export default LazyImageProvider;
